import React from 'react'
import { IconCheck } from '@tabler/icons-react'
import { isEmpty } from 'lodash'
import { Button } from '@/components/buttons/Button'

import { Pill } from '@/components/pills/Pill'

import './FilterDropdownOptions.scss'

export const FilterDropdownOptions = ({ optionSets = [], handleChange, isClearable }) => {
  return (
    <div className="filter-dropdown-options">
      {optionSets.map((optionSet) => (
        <div className="filter-dropdown-options__section" key={optionSet.accessor}>
          {isEmpty(optionSet.options) ? (
            <div className="padding">No options found</div>
          ) : (
            optionSet.options.map((option) => (
              <Button
                fullWidth
                basic
                className="dropdown-action-button"
                key={option.value}
                onClick={() => {
                  if (isClearable && option.value === optionSet.selectedValue) {
                    handleChange(optionSet.accessor, '')
                  } else {
                    handleChange(optionSet.accessor, option.value)
                  }
                }}
              >
                {option.label}
                {option.count && <Pill xs>{option.count}</Pill>}
                {option.value === optionSet.selectedValue && (
                  <IconCheck className="icon-svg status-brand" />
                )}
              </Button>
            ))
          )}
        </div>
      ))}
    </div>
  )
}
